const greyScale = {
  black: '#000000',
  black200: 'rgba(0,0,0,0.15)',
  grey700: '#C5CDD8',
  grey300: '#F2F2F2',
  white: '#FFFFFF',
  white200: '#2A3F65',
  background: '#243758',
};

const corporateColors = {
  primary: '#2EC4B6',
  secondary: '#1E3050',
  secondary200: 'rgba(30, 48, 80, 0.6)',
  tertiary: '#D0D8E8',
  verticalGradient: 'linear-gradient(to bottom, #162844 0%, #2D4A7A 50%, #3B5E99 100%)',
  horizontalGradient: 'linear-gradient(to right, #2EC4B6 0%, #FF6B6B 100%)',
};

const shadows = {
  colorShadow: 'rgba(0, 0, 0, 0.4)',
  whiteShadow: 'rgba(255, 255, 255, 0.15)',
  whiteShadow200: 'rgba(255, 255, 255, 0.08)',
};

const secondaryColors = {
  anakiwa: '#2EC4B6',
  anakiwaBackground: 'rgba(46, 196, 182, 0.15)',
  lightPink: '#FF4FB3',
  heliotrope: '#7F60FF',
  violet: '#162844',
  maroon: '#FF6B6B',
  cerise: '#E85D75',
};

const flashColors = {
  error: '#EC5871',
  success: '#87CA81',
  warning: '#FFC122',
  info: '#2E87EB',
};

const Colors = {
  ...greyScale,
  ...corporateColors,
  ...secondaryColors,
  ...flashColors,
  ...shadows,
};

export default Colors;
